import events from "../events/EventsObservable";
import SystemClock from "./SystemClock";
import {inject, injectable} from "inversify";
import ITime from "./ITime";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig, {CONFIG_PARAMS, MODES} from "./SystemConfig";

export const TIME_EVENTS = {
    "TIME_UPDATE": "TIME_UPDATE",
};

function padTime(time) {
    if(time < 10) {
        return "0" + time;
    }

    return time + "";
}

function getNow() {
    let time = new Date();

    return  {
        h: padTime(time.getHours()),
        m: padTime(time.getMinutes()),
        //s: padTime(time.getSeconds())
    }
}

@injectable()
class SystemTime implements ITime {

    private config: SystemConfig;
    public clock: SystemClock;
    private _time: ITime;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
    ) {
        this.config = config;
        this.clock = new SystemClock();

        this._time = null;

        this.clock.setTick(() =>
            events.dispatch(TIME_EVENTS.TIME_UPDATE, this._time ? this._time.getTime() : getNow()));
    }

    setTime(time: ITime) {
        this._time = time;
    }

    start() {
        if (this.config.get(CONFIG_PARAMS.MODE) === MODES.REAL || (this.config.get(CONFIG_PARAMS.LEGISLATION) === "pt")) {
            this.clock.start();
        }
    }

    stop() {
        this.clock.stop();
    }

    getTime(): { h: string; m: string; s?: string } {
        return getNow();
    }
}

export default SystemTime;